import classNames from 'classnames';
import { Button, Icon, Text } from 'worldover/ui-components';

export const LandingPageFreeTierBookDemo = () => {
  return (
    <div className='flex flex-col gap-[14px]'>
      <div className='flex flex-row gap-2'>
        <Icon
          name='Globe'
          height={18}
          width={18}
          className='text-slate-400 translate-y-[1px]'
        />
        <Text variant='bodySemi' color='text-slate-400'>
          Access more
        </Text>
      </div>
      <a
        href='https://www.worldover.io/book-a-demo'
        target='_blank'
        rel='noopener noreferrer'
        className={classNames(
          'relative',
          'grid grid-flow-col place-items-center h-[320px] w-full',
          'border-[1px] border-slate-200 rounded-lg',
          'bg-slate-200',
          'overflow-hidden',
          'shadow-lg',
          "glint-effect",
          'cursor-pointer',
        )}
      >
        <div className='flex flex-col justify-end h-full w-full p-[40px]'>
          <div className='flex flex-col gap-[20px] max-w-[220px]'>
            <div className='flex flex-col gap-[20px]'>
              <Text variant='bodyReg' color='text-slate-600'>
                Unlock unlimited potential
              </Text>
              <Text variant='subtitle' color='text-slate-800'>
                Explore Worldover's end to end R&D platform.
              </Text>
            </div>
            <Button isPrimary size='small' className='rounded-[8px] pointer-events-none'>
              <Text variant='smallSemi' color='text-white'>
                Book a demo
              </Text>
            </Button>
          </div>
        </div>
        <div
          className={classNames('absolute right-[10px]', 'translate-x-[30%]')}
        >
          <div className='relative grid grid-cols-2 place-items-center gap-[20px]'>
            <div className='translate-y-[-40px]'>
              <Icon name='Molecule' height={185} width={195} />
            </div>
            <div className='absolute top-[15px] left-[60px] h-[268px] w-auto'>
              <img
                src='/images/formulation-designer.png'
                alt='Formulation Designer'
                className='h-full w-auto'
              />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
